module.exports = __webpack_public_path__ + "img/word.208c54a8.png";